var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['link', { link_dashed: _vm.dashed }],attrs:{"href":_vm.link,"title":_vm.title,"target":"_blank"}},[_vm._v(_vm._s(_vm._f("stringMaxLength")(_vm.sanitizeText,_vm.length)))])}
var staticRenderFns = []

export { render, staticRenderFns }